import "./generate.css";
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import GenerateHeader from "../../Components/Generate/GenerateHeader/GenerateHeader";
import GenerateBody from "../../Components/Generate/GenerateBody/GenerateBody/GenerateBody";
import { fetchAllWorkspaces, setCurrentWorkSpace } from '../../actions/workspaceActions';
import { saveLinkedInAd, saveTagline, saveGoogleAd, saveAmazonDesc, saveBlogIdeas, saveBlogQuote, saveBlogIntro, saveDisplayAds, saveFaq, savePainAgitate, saveFacebookAdd } from '../../actions/generateActions';
import { editFile } from '../../actions/projectActions';
import SaveFile from "./SaveFile";
import { useLocation } from 'react-router-dom';
import { EDIT_FILE_RESET } from '../../constants/projectConstants';
import {
  GENERATE_LINKEDINAD_RESET,
  GENERATE_TAGLINE_RESET,
  GENERATE_AMAZONDESC_RESET,
  GENERATE_GOOGLEAD_RESET,
  GENERATE_BLOGQUOTE_RESET,
  GENERATE_BLOGINTRO_RESET,
  GENERATE_BLOGIDEAS_RESET,
  GENERATE_DISPLAYADS_RESET,
  GENERATE_FAQ_RESET,
  GENERATE_PAINAGITATE_RESET,
  GENERATE_FACEBOOKAD_RESET,
} from '../../constants/generateConstants';
import { CodeSharp } from "@material-ui/icons";

function App({ resultBox, header, sidebar, type }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const [saveFileDialog, setSaveFileDialog] = useState(false);
  const [bookmarkArray, setBookmarkArray] = useState([false, false, false, false, false]);
  const [isBookmarked, setIsBookmarked] = useState(false);
  const userLogin = useSelector(state => state.userLogin);
  const { userInfo } = userLogin;

  const allWorkspaces = useSelector(state => state.allWorkspaces);
  const { workspaceDetails } = allWorkspaces;

  const currentWorkSpace = useSelector(state => state.currentWorkSpace);
  const { currentWorkspaceDetails } = currentWorkSpace;

  const linkedinAdGenerate = useSelector(state => state.linkedinAdGenerate);
  const { companyName: linkedInCompanyName, companyDesc: linkedInCompanyDesc } = linkedinAdGenerate;

  const taglineGenerate = useSelector(state => state.taglineGenerate);
  const { companyName: taglineCompanyName, companyDesc: taglineCompanyDesc } = taglineGenerate;

  const googleAdGenerate = useSelector(state => state.googleAdGenerate);
  const { googleAddHeadlines, websiteURL, adDesc } = googleAdGenerate;

  const blogIdeasGenerate = useSelector(state => state.blogIdeasGenerate);
  const { blogDesc: blogIdeasBlogDesc } = blogIdeasGenerate;

  const blogQuoteGenerate = useSelector(state => state.blogQuoteGenerate);
  const { blogTitle: blogQuoteBlogTitle, blogDesc: blogQuoteBlogDesc } = blogQuoteGenerate;

  const blogIntroGenerate = useSelector(state => state.blogIntroGenerate);
  const { blogTitle: blogIntroBlogTitle, blogDesc: blogIntroBlogDesc } = blogIntroGenerate;

  const displayAdsGenerate = useSelector(state => state.displayAdsGenerate);
  const {topic: displayAdstopic} = displayAdsGenerate;
  

  


  const FaqGenerate = useSelector(state => state.FaqGenerate);
  const {topic: Faqtopic} = FaqGenerate;

  const painAgitateGenerate = useSelector(state => state.painAgitateGenerate);
  const {topic: painAgitatetopic} = painAgitateGenerate;
  

  const facebookAdGenerate = useSelector(state => state.facebookAdGenerate);
  const {facebookAddSubHeading, facebookAddSubText, facebookAddwebsiteURL, facebookadDesc} = facebookAdGenerate;
  

  const fileEdit = useSelector(state => state.fileEdit);
  const { editFileInfo } = fileEdit;

  useEffect(() => {
    if (!workspaceDetails) {
      dispatch(fetchAllWorkspaces());
    }
    if (workspaceDetails && !currentWorkspaceDetails) {
      dispatch(setCurrentWorkSpace(workspaceDetails[0]));
    }
  }, [workspaceDetails, currentWorkspaceDetails])

  useEffect(() => {
    if (editFileInfo) {
      dispatch({ type: EDIT_FILE_RESET })
      handleClose();
    }
  }, [editFileInfo, dispatch])

  useEffect(() => {
    if (location.state) {
      let tempBookmarkArr = [];
      location.state.results.forEach(function (val) {
        if (val.bookmark === true) {
          tempBookmarkArr.push(true);
        } else {
          tempBookmarkArr.push(false);
        }
      })
      setBookmarkArray(tempBookmarkArr);
    }
  }, [location.state])

  const [generateArray, setGenerateArray] = useState([]);

  const handleClose = () => {
    setSaveFileDialog(false);
    if (type === 'LINKEDIN_ADD') {
      dispatch({ type: GENERATE_LINKEDINAD_RESET });
    }

    if (type === 'TAGLINE') {
      dispatch({ type: GENERATE_TAGLINE_RESET });
    }

    if (type === 'amazonDesc') {
      dispatch({ type: GENERATE_AMAZONDESC_RESET });
    }

    if (type === 'GOOGLE_ADD') {
      dispatch({ type: GENERATE_GOOGLEAD_RESET });
    }
    if (type === 'BLOG_IDEAS') {
      dispatch({ type: GENERATE_BLOGIDEAS_RESET });
    }

    if (type === 'BLOG_QUOTE') {
      dispatch({ type: GENERATE_BLOGQUOTE_RESET });
    }

    if (type === 'BLOG_INTRO') {
      dispatch({type: GENERATE_BLOGINTRO_RESET});
    }

    if (type === 'DISPLAY_ADS') {
      dispatch({type: GENERATE_DISPLAYADS_RESET});
    }

    
    if (type === 'FAQ') {
      dispatch({type: GENERATE_FAQ_RESET});
    }

    if (type === 'PAIN_AGITATE_SOLUTION') {
      dispatch({type: GENERATE_PAINAGITATE_RESET});
    }

    if (type === 'FACEBOOK_ADD') {
      dispatch({ type: GENERATE_FACEBOOKAD_RESET });
    }



  

    history.push("/home");
  };

  const handleSave = (fileData) => {
    // let fileType = type.toUpperCase()
    let resultData = [];
    let companyInfo = {
      companyName: 'Company Name',
      description: "Description",
    }

    
   
    

    if (type === 'LINKEDIN_ADD') {
      companyInfo.companyName = linkedInCompanyName;
      companyInfo.description = linkedInCompanyDesc;
    }
    if (type === 'TAGLINE') {
      companyInfo.companyName = taglineCompanyName;
      companyInfo.description = taglineCompanyDesc
    }

    if (type === 'GOOGLE_ADD') {
      companyInfo.description = adDesc
    }

    if (type === 'BLOG_IDEAS') {
     
      companyInfo.description = blogIdeasBlogDesc;
    }

    if (type === 'BLOG_QUOTE') {
      companyInfo.companyName = blogQuoteBlogTitle;
      companyInfo.description = blogQuoteBlogDesc;
    }

    if (type === 'BLOG_INTRO') {
      companyInfo.companyName = blogIntroBlogTitle;
      companyInfo.description = blogIntroBlogDesc;
    }

    if (type === 'DISPLAY_ADS') {
      companyInfo.description = displayAdstopic;
    }

    if (type === 'FAQ') {
      companyInfo.description = Faqtopic;

    }

    if (type === 'PAIN_AGITATE_SOLUTION') {
      companyInfo.description = painAgitatetopic;    

    }

    if (type === 'FACEBOOK_ADD') {
      companyInfo.description = facebookadDesc;
    }


    let i = 0;
    let isBookmarkWhole = isBookmarked
    for (let val of generateArray) {
      let resultVal = {
        content: val.content,
        bookmark: bookmarkArray[i]
      }
      if (bookmarkArray[i] === true) {
        isBookmarkWhole = true;
      }
      i = i + 1;
      resultData.push(resultVal);
    }
    // if (generateArray.length > 0 && folderId) {
    // let firstIndexVal = { content: resultData[0].content, bookmark: isBookmarked };
    // resultData[0] = firstIndexVal;
    let finalData = {
      name: fileData.name,
      bookmark: isBookmarkWhole,
      results: resultData,
      fileId: fileData._id
    }
    console.log(finalData);
    dispatch(editFile(finalData));
    //}
  }

  const handleResult = () => {
    // if (!location.state) {
    if (type === 'LINKEDIN_ADD' && generateArray.length > 0) {
      dispatch(saveLinkedInAd(linkedInCompanyName, generateArray, linkedInCompanyDesc));
    }

    if (type === 'TAGLINE' && generateArray.length > 0) {
      dispatch(saveTagline(taglineCompanyName, generateArray, taglineCompanyDesc))
    }

    if (type === 'amazonDesc' && generateArray.length > 0) {
      dispatch(saveAmazonDesc(generateArray));
    }

    if (type === 'GOOGLE_ADD' && generateArray.length > 0) {
      dispatch(saveGoogleAd(googleAddHeadlines, generateArray, websiteURL, adDesc));
    }
    //}

    if (type === 'BLOG_IDEAS' && generateArray.length > 0 ){
      dispatch(saveBlogIdeas(  generateArray, blogIdeasBlogDesc));
    }

    
    if (type === 'BLOG_QUOTE' && generateArray.length > 0 ){
      dispatch(saveBlogQuote( blogQuoteBlogTitle, generateArray, blogQuoteBlogDesc));
    }
     
    if (type === 'BLOG_INTRO' && generateArray.length > 0 ){
      dispatch(saveBlogIntro( blogIntroBlogTitle, generateArray, blogIntroBlogDesc));
    }

    if (type === 'DISPLAY_ADS' && generateArray.length > 0) {
      dispatch(saveDisplayAds(displayAdstopic, generateArray));
    }

    // if (type === 'FAQ' && generateArray.length > 0) {
    //   dispatch(saveFaq(Faqtopic, generateArray));
    // }

    // if (type === 'PAIN_AGITATE_SOLUTION' && generateArray.length > 0) {
    //   debugger
    //   dispatch(savePainAgitate(painAgitatetopic, generateArray));
    // }

    if (type === 'FACEBOOK_ADD' && generateArray.length > 0) {
      dispatch(saveFacebookAdd(facebookAddSubHeading, facebookAddSubText, generateArray, facebookAddwebsiteURL, facebookadDesc));
    }


    if (generateArray.length > 0 && !location.state) {
      setSaveFileDialog(true);
    } else if (location.state) {
      handleSave(location.state)
    } else {
      history.push('/home');
    }
  }

  useEffect(() => {
    if (!userInfo) {
      history.push("/login");
    }
  }, [userInfo, history])

  return (
    <div className="mainsoftwarelayout__body">
      <GenerateHeader header={header} handleResult={handleResult} type={type} />
      <GenerateBody resultBox={resultBox}
        sidebar={sidebar} type={type}
        setGenerateArray={setGenerateArray}
        setIsBookmarked={setIsBookmarked}
        isBookmarked={isBookmarked}
        setBookmarkArray={setBookmarkArray}
        bookmarkArray={bookmarkArray} />
      {saveFileDialog && <SaveFile saveFileDialog={saveFileDialog} setSaveFileDialog={setSaveFileDialog} type={type} generateArray={generateArray} isBookmarked={isBookmarked} bookmarkArray={bookmarkArray} />}
    </div>
  );
}

export default App;
